import React, {FC} from 'react';
import styled from 'styled-components';

import {Plural} from '../../../../../libs/shared/core/src/helpers/internationalization/react';
import {Icon} from '../../../../../libs/shared/ui/src/components/icon/icon';
import {fontWeights} from '../../../../../libs/shared/ui/src/styles/fontStyles';
import {useAppSelector} from '../../../../helpers/appReduxHelpers';
import {getDaysLeftInTrial} from '../../../../store/data/company/companySelectors';

/*
 * Props.
 */

interface BottomBarTrialInfoProps {}

/*
 * Style.
 */

interface StyleProps {
  $isTrialEnded: boolean;
  $isHidden: boolean;
}

const StyledDiv = styled.div<StyleProps>`
  display: flex;
  overflow: hidden;
  align-items: center;
  gap: 4px;

  color: ${(p) => (p.$isTrialEnded ? p.theme.palette.red.shade50 : p.theme.text)};
  font-size: 13px;
  line-height: 16px;
  font-weight: ${fontWeights.semibold};

  visibility: ${(p) => (p.$isHidden ? 'hidden' : 'visible')};
`;

const StyledTextDiv = styled.div`
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

/*
 * Component.
 */

export const BottomBarTrialInfo: FC<BottomBarTrialInfoProps> = (props) => {
  const daysLeftInTrial = useAppSelector(getDaysLeftInTrial);

  const isTrialEnded = daysLeftInTrial <= 0;

  // Prevents the trial info width from flickering when the trial end is set initially.
  const daysLeftInTrialPlaceholder = 14;

  return (
    <StyledDiv $isTrialEnded={isTrialEnded} $isHidden={!Number.isFinite(daysLeftInTrial)}>
      {isTrialEnded && <Icon name="warningFilledSmall" />}

      <StyledTextDiv>
        <Plural
          id="bottom-bar-trial-info"
          value={Number.isFinite(daysLeftInTrial) ? daysLeftInTrial : daysLeftInTrialPlaceholder}
          _0="Your trial has ended"
          one="Growth trial ends within 24 hours"
          other="Growth trial ends in # days"
        />
      </StyledTextDiv>
    </StyledDiv>
  );
};
